import { registerComponent, debounce } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-filter",
  class AdoptionSearchFilter extends WYATTElement {
    constructor() {
      super();

      this.courseData = null;

      this.inputElement = this.querySelector("input");
    }

    get adoptionSearchCoursesInstance() {
      return this.closest(".adoption-search").querySelector(
        "adoption-search-courses"
      );
    }

    connectedCallback() {
      this.subscribe(
        WYATT.config.pubsub.events.adoptionSearchFormSubmit,
        this.handleAdoptionSearchFormSubmit.bind(this)
      );

      this.inputElement.addEventListener(
        "input",
        debounce(this.handleInput.bind(this), 300)
      );
    }

    handleAdoptionSearchFormSubmit(courseData) {
      this.courseData = courseData;

      this.classList.remove("hidden");

      this.inputElement.value = "";
    }

    handleInput() {
      const inputValue = this.inputElement.value;

      this.adoptionSearchCoursesInstance.addLoading();

      const filteredCourseData = this.filterCourseData(inputValue);

      this.publish(
        WYATT.config.pubsub.events.adoptionSearchFilterInput,
        filteredCourseData
      );

      this.adoptionSearchCoursesInstance.removeLoading();
    }

    filterCourseData(inputValue) {
      if (!this.courseData || !this.courseData.items) {
        return this.courseData;
      }

      // If no input value, return original data
      if (!inputValue || inputValue.trim() === "") {
        return this.courseData;
      }

      const filteredItems = [];

      const searchTerm = inputValue.toLowerCase().trim();

      this.courseData.items.forEach((item) => {
        const filteredSections = item.sections.filter((section) => {
          // Join all section values and check for substring match
          const searchableText = Object.values(section).join(" ").toLowerCase();
          return searchableText.includes(searchTerm);
        });

        // If any sections match, include the item with only matching sections
        if (filteredSections.length > 0) {
          filteredItems.push({ ...item, sections: filteredSections });
        }
      });

      return {
        count: filteredItems.length,
        items: filteredItems,
      };
    }
  }
);
